import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
export class OrganizationEmail extends AutoEncoder {
    id;
    /**
     * Name of this person / group
     */
    name = null;
    email;
    /**
     * Whether this e-mail might get used as a global default one when we could not find a different one
     */
    default = false;
    /**
     * Only usable by users with full permissions
     */
    restricted = false;
    getDiffName() {
        if (this.name) {
            return this.name + ' <' + this.email + '>';
        }
        return this.email;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], OrganizationEmail.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], OrganizationEmail.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder })
], OrganizationEmail.prototype, "email", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], OrganizationEmail.prototype, "default", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], OrganizationEmail.prototype, "restricted", void 0);
//# sourceMappingURL=OrganizationEmail.js.map